// extracted by mini-css-extract-plugin
export default {"fieldbody":"a6ed71371338bfc1f1f7","description":"cc0bf854fead46fbcd1a","component":"daf3d6d6601964078e98","subfields":"af96790d0cbcd4d8270c","noticeview":"eb679331534f816da4ef"};